<template>
  <div>
    <div class="outer">
      <header class="header">
        <div class="header-content">
          <div class="header-button">
            <fai
              v-if="hamburguer"
              icon="bars"
              class="fa-2x hamburguesa ripple"
              @click="onClickHamburguer()"
            />
            <div
              v-if="hamburguer"
              class="caja"
              @click="gotoInicio()"
              style="block"
            >
              Inicio
            </div>
            <div
              v-if="hamburguer"
              class="caja"
              @click="installer()"
              :style="{ display: installBtn }"
            >
              Instalar
            </div>
            <div v-if="visibleAddHomeScreenIos">
              <div
                v-if="hamburguer"
                style="block"
                class="caja"
                @click="mostrarIOS()"
              >
                Instalar
              </div>
            </div>
          </div>
          <img
            src="@/assets/logo_mmt_blanco_transparente.png"
            height="80rem"
            class="logo"
            @click="gotoInicio"
          />
        </div>
      </header>
    </div>
    <div :style="{ display: displayIOS }">
      <div class="Instalar" style="margin: 10px">
        <p @click="close()">
          Pulsa
          <img src="@/assets/share-ico.png" style="width: 25px" /> en tu
          dispositivo y después "Añadir a pantalla de inicio" para instalar MMT
          Seguros
        </p>
      </div>
    </div>
    <div v-if="menu" class="overlay" @click="closeMenu()" />
    <MenuInicio v-if="menu" class="menuDesplegable" @elegido="closeMenu()" />
  </div>
</template>

<script>
let installPrompt;
let menuYaAbiertoEstaSesion = false;

// Llamar al cerrar sesión para que la próxima vez que entre el usuario
// se abra el menú automáticamente otra vez en móvil.
export function resetMenuAbierto() {
  menuYaAbiertoEstaSesion = false;
}

export default {
  props: {
    hamburguer: { type: Boolean, required: true },
  },

  data() {
    // Solo abrimos el menú automáticamente la primera vez en toda la sesión,
    // y solo en móvil. En navegaciones posteriores arranca cerrado.
    const esMovil = window.innerWidth < 768;
    const abrir = esMovil && !menuYaAbiertoEstaSesion;
    if (abrir) menuYaAbiertoEstaSesion = true;

    return {
      menu: abrir,
      installBtn: "none",
      displayIOS: "none",
    };
  },

  created() {
    console.log("Creamos cabecera");

    window.addEventListener("beforeinstallprompt", (ex) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      ex.preventDefault();
      // Stash the event so it can be triggered later.
      installPrompt = ex;

      this.installBtn = "block";
    });
  },

  computed: {
    userAgente() {
      return window.navigator.userAgent.toLowerCase();
    },

    platform() {
      return window.navigator.platform;
    },

    isIos() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return (
        /iphone|ipad|ipod/.test(userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      );
    },

    isInStandaloneMode() {
      return "standalone" in window.navigator && window.navigator.standalone;
    },

    visibleAddHomeScreenIos() {
      return this.isIos && !this.isInStandaloneMode;
    },
  },

  methods: {
    onClickHamburguer() {
      console.log("Hamburguesa pulsada");
      this.menu = true;
    },
    closeMenu() {
      this.menu = false;
    },
    gotoInicio() {
      if (!this.hamburguer) return;
      this.$router.push({ name: "inicio" });
    },
    installer() {
      console.log("instalarSw pulsada");
      this.installBtn = "none";

      installPrompt.prompt();
      // Wait for the user to respond to the prompt
      installPrompt.userChoice.then((result) => {
        if (result.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        } else {
          console.log("User dismissed the A2HS prompt");
        }
        installPrompt = null;
      });
    },
    mostrarIOS() {
      this.displayIOS = "block";
    },
    close() {
      this.displayIOS = "none";
    },
  },
};
</script>

<style lang="scss" scoped>
.outer {
  height: 4.5rem;
  width: 100%;
}
.header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 999;
}
.header-content {
  background-color: $colorMMT;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 4.5rem;
}
.header-button {
  background-color: $colorMMT;
  display: flex;
  flex-flow: row nowrap;
  //justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 4.5rem;
}

.hamburguesa {
  color: white;
  margin: 6px;
  margin-left: 0.75rem;
  cursor: pointer;
}
.logo {
  margin-right: 1rem;
  cursor: pointer;
}

/*---------------------
 menu desplegable 
-----------------------*/
.overlay {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  z-index: 9998;
}

.menuDesplegable {
  position: fixed;
  top: 0;
  left: 0;
  max-width: 80vw;
  height: 100vh;
  z-index: 9999;
  overflow-y: auto;
  padding: 10px;
  flex-grow: 1;
  background-color: $azulOscuroMMT;
  box-shadow: 3px 3px 5px 6px black; /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
}

.caja {
  color: $colorMMT;
  text-decoration: none;
  font-weight: bold;
  text-align: center;
  background: white;
  margin: 4px;
  padding: 7px 10px 7px 10px;
  border-radius: 5px 5px 5px 5px;
  //border: 2px solid #5878ca;
}

.instalar {
  font-size: 100%;
  font-weight: bold;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
  padding-bottom: 10px;
  background-color: white;
  z-index: 2000;
  text-align: center;
  margin: auto;
}

@media screen and (min-width: 768px) {
  .menuDesplegable {
    display: block;
    min-width: 25rem;
  }
}
</style>